import { InjectionToken, Provider, Type } from '@angular/core';

import { environment } from '@drf/environments';

export function provideMockableApi<TContract, TReal extends TContract, TMock extends TContract>(
  token: InjectionToken<TContract>,
  realApi: Type<TReal>,
  mockApi: Type<TMock>,
): Provider {
  return {
    provide: token,
    useClass: environment.useMocks ? mockApi : realApi,
  };
}
